// extracted by mini-css-extract-plugin
export default {"div":"Slick_div__LtUot"};